"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

const Focus = props => /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
  width: 18,
  height: 18,
  viewBox: "0 0 18 18"
}, props), /*#__PURE__*/_react.default.createElement("path", {
  className: "fill",
  d: "M9 .7a8.3 8.3 0 110 16.6A8.3 8.3 0 019 .7zm0 .6a7.7 7.7 0 110 15.4A7.7 7.7 0 019 1.3zm.5 1.016V5l-.008.09A.5.5 0 018.5 5V2.316l-.338.042-.25.037a6.7 6.7 0 00-5.554 5.767l-.042.338H5l.09.008A.5.5 0 015 9.5H2.316l.042.338.037.25a6.7 6.7 0 005.767 5.554l.338.042V13l.008-.09A.5.5 0 019.5 13v2.684l.338-.042.25-.037a6.7 6.7 0 005.554-5.767l.042-.338H13l-.09-.008A.5.5 0 0113 8.5h2.684l-.042-.338-.037-.25a6.7 6.7 0 00-5.767-5.554L9.5 2.316zm.599.691L10.1 5a1.1 1.1 0 01-2.194.12L7.9 5V3.007l-.157.03a6.101 6.101 0 00-4.706 4.706l-.03.157H5a1.1 1.1 0 011.094.98L6.1 9a1.1 1.1 0 01-.98 1.094L5 10.1H3.007l.03.157a6.101 6.101 0 004.706 4.706l.157.029V13a1.1 1.1 0 01.98-1.094L9 11.9a1.1 1.1 0 011.094.98l.006.12-.001 1.992.158-.03a6.101 6.101 0 004.706-4.705l.029-.157H13a1.1 1.1 0 01-1.094-.98L11.9 9a1.1 1.1 0 01.98-1.094L13 7.9h1.992l-.03-.157a6.101 6.101 0 00-4.705-4.706l-.158-.03zM9 7.9a1.1 1.1 0 110 2.2 1.1 1.1 0 010-2.2z",
  fillRule: "nonzero"
}));

var _default = Focus;
exports.default = _default;